// Wave 3.45 Phase 2 — Broken Packet primitive
// =============================================================================
// BrokenBadge & BrokenBanner
// =============================================================================
// Small reusable presentational components shared across Diamond / Color
// Stone / Pearl list + detail pages. Visual conventions:
//   • Broken badge: rose pill with PackageX icon. Sits inline with the
//     packet number / title.
//   • Broken banner: full-width rose alert at the top of Packet Detail.
import React from 'react';
import { PackageX, AlertTriangle } from 'lucide-react';

/** Inline pill shown next to a broken packet's packet_no. */
export function BrokenBadge({ size = 'sm', testId }) {
  const cls =
    size === 'lg'
      ? 'text-xs px-2.5 py-0.5'
      : 'text-[10px] px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 ${cls} rounded-full bg-rose-50 border border-rose-200 text-rose-700 font-medium`}
      data-testid={testId || 'broken-badge'}
    >
      <PackageX size={size === 'lg' ? 12 : 10} />
      Broken
    </span>
  );
}

/** Full-width banner shown at the top of a Broken Packet Detail page. */
export function BrokenBanner({ packetNo, testId }) {
  return (
    <div
      className="mb-3 flex items-start gap-2 px-3 py-2 rounded-md border border-rose-200 bg-rose-50 text-rose-800 text-[12px]"
      data-testid={testId || 'broken-banner'}
    >
      <AlertTriangle size={14} className="mt-0.5 flex-shrink-0" />
      <div>
        <div className="font-medium">
          {packetNo} is a Broken (salvage) Packet.
        </div>
        <div className="text-rose-700/80 text-[11px] mt-0.5">
          This packet collects damaged stones returned by goldsmiths. Material{' '}
          <strong>cannot be issued, transferred or sold</strong> from a broken packet.
          Outgoing actions are disabled.
        </div>
      </div>
    </div>
  );
}

export default BrokenBadge;
